import { ApiOptions, UserId } from '@csp/csp-common-model';
import { UserFactory } from '@csp/csp-common-user';
import { toRestOptions } from '@csp/csp-fe-auth';
import { UserRestServiceV1 } from '@csp/dmdp-api-client';
import { Page } from '@csp/dmdp-api-common-dto';
import { UserIncludeFieldType, UsersV1 } from '@csp/dmdp-api-user-dto';
import { uniq } from 'lodash';
import { UserPage } from '../model/UserPage';
import { UserQuery } from '../model/UserQuery';
import { UserQueryIn } from '../model/UserQueryIn';

const toNextPage = (pageSize: number, next?: string): Page => ({
  next,
  limit: pageSize,
  count: true,
});

const query = async (userQueryIn: UserQueryIn, next?: string, apiOptions?: ApiOptions): Promise<UserPage> => {
  const queryV1 = UserQuery.from(userQueryIn);
  const usersV1: UsersV1 = await UserRestServiceV1.query(
    toRestOptions(apiOptions),
    queryV1,
    toNextPage(userQueryIn.pageSize, next),
  );

  const patients = usersV1.users?.map(userV1 => UserFactory.from(userV1)) ?? [];

  return { users: patients, paging: usersV1.paging };
};

const byUserIds = async (
  userIds: UserId[],
  fields: UserIncludeFieldType[] = UserQuery.defaultFields,
  pageSize = 5_000,
  next?: string,
  apiOptions?: ApiOptions,
): Promise<UserPage> =>
  query(
    { criteria: { userIds: uniq(userIds) }, fields, sorting: UserQuery.defaultSorting, pageSize },
    next,
    apiOptions,
  );

export const UserQueryService = {
  byUserIds,
  query,
};
